const condo_initial = (payload) => {
  return {
    type: "condoInitial",
    payload,
  };
};

export default condo_initial;
